const isNumber = value => {
  if (`${value}`.trim() === "") return false;

  return Number.isFinite(value) || (
    Number.isFinite(Number(value)) && typeof value === 'string'
  );
};

export default isNumber;
